// @ts-nocheck
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ButtonComponents from './ButtonComponents'; // Import the common Button component

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dialogText?: string;
  sx?:any;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  dialogText = "Are you sure you want to proceed?",  // Default message
  sx
}) => {
  return (
    <Dialog disableEscapeKeyDown={true} open={open} onClose={onClose} aria-labelledby="confirmation-dialog" data-testid="confirmation-dialog" sx={{zIndex:"999999"}}>
      <DialogContent sx={{ pt: "30px" }} data-testid="dialog-content">
        <Box display="flex" justifyContent="center" alignItems="center" mb={2} data-testid="error-icon-box">
          <ErrorOutlineIcon style={{ color: '#FF5C39' }} data-testid="error-icon" />
        </Box>
        <DialogContentText sx={{ textAlign: 'center', color: "#3b3b3b", fontSize: 16, fontWeight: 500 }} data-testid="dialog-text">
          {dialogText}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: "25px" }} data-testid="dialog-actions">
        <ButtonComponents
          label="No"
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: '#FF5C39',
            color: '#FF5C39',
            '&:hover': { backgroundColor: '#ffe8e2' },
          }}
          data-testid="no-button"
        />
        <ButtonComponents
          label="Yes"
          onClick={onConfirm}
          sx={{
      
            backgroundColor: '#FF5C39',
            color: '#fff',
            '&:hover': { backgroundColor: '#e65232' },
            ...sx
          }}
          data-testid="yes-button"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
